import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Form,
  Input,
  Modal,
  Upload } from 'antd';

import { withTranslation } from 'react-i18next';
import {
  UploadOutlined,
} from '@ant-design/icons';


const RESET_STATE = (state = {}) => {
  return {
    fileList: [],
    ...state,
  }
}

class UserProfileEditForm extends React.Component {
  static propTypes = {
    // form: PropTypes
    visible: PropTypes.bool,
    confirmLoading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    me: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      phone_number: PropTypes.string,
      email: PropTypes.string,
    }).isRequired,
  }

  static defaultProps = {
    visible: false,
  }

  constructor(props) {
    super(props);
    this.state = RESET_STATE();
    this.onCancel = this.onCancel.bind(this);
    this.onOk = this.onOk.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible && !this.props.visible) {
      this.props.form.resetFields();
      this.setState(RESET_STATE());
      return
    }
  }

  normFile(e) {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  onCancel() {
    this.props.onCancel();
  }

  async onOk() {
    const { fileList } = this.state;
    this.props.form.setFieldsValue({
      avatar: (fileList.length > 0) ? fileList[0] : null,
    })
    let isFormValid = await this.props.onOk();
    if (isFormValid && isFormValid.response) {
      this.setState({
        fileList: [],
      });
    }
  }

  render() {
    // TODO: check out https://ant.design/components/upload/ "Avatar" section
    const { visible, confirmLoading, form } = this.props;
    const me = this.props.me;

    const formItemLayout = {
      labelCol: { span: 12 },
      wrapperCol: { span: 12 },
    };

    return (
      <Modal
        visible={ visible }
        title="Update user profile"
        okText={ this.props.t("actions.Submit") }
        onCancel={ this.onCancel }
        onOk={ this.onOk }
        confirmLoading={ confirmLoading }
      >
        { this.props.children }
        <Form form={this.props.form} layout="horizontal">
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.Settings.FirstName") }
           name="first_name" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputFirstName") }!` },
              ]} initialValue={me.first_name}>
            <Input />
          </Form.Item>
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.Settings.LastName") }
           name="last_name" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputLastName") }!` },
              ]} initialValue={me.last_name}>
            <Input />
          </Form.Item>
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.Settings.Phone") }
           name="phone_number" rules={[
                { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputYourPhoneNumber") }!` },
              ]} initialValue={me.phone_number}>
            <Input />
          </Form.Item>
          <Form.Item
            hasFeedback
            {...formItemLayout}
            label={ this.props.t("Profile.Settings.Email") }
           name="email" rules={[
                  { required: true, message: `${ this.props.t("Profile.messages.Form.PleaseInputYourEmail") }!` },
                ]} initialValue={me.email}>
            <Input />
          </Form.Item>
          <Form.Item
            label={ this.props.t("Profile.Settings.ProfilePicture") }
            { ...formItemLayout }
           name="avatar">
            <div className="dropbox">
              <Upload
                  accept="image/*"
                  multiple={ false }
                  onRemove={
                    (avatar) => {
                      this.setState({ fileList: [] });
                    }
                  }
                  beforeUpload={
                    (avatar) => {
                      this.setState({
                        fileList: [avatar],
                      });
                      return false;
                    }
                  }
                  fileList={ this.state.fileList }
                  name="avatar"
                >
                  <Button>
                    <UploadOutlined/> { this.props.t("actions.ClickToUpload") }
                  </Button>
                </Upload>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const WrappedUserProfileEditForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <UserProfileEditForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUserProfileEditForm);
